export enum CompanyModule{
    Parent = 9,
    ParentRegistration = 10,
    Payment = 60,
    Event = 62,
}